import AppRoute from "models/AppRoute"

interface IManageReferenceValuesRouteParams {
    referenceNumber: string
}

const ManageReferenceValuesRoute = new AppRoute<IManageReferenceValuesRouteParams>({
    route: "/manage-reference-values/:referenceNumber",
    navbar: true,
    authRequired: true,
})

export default ManageReferenceValuesRoute
